module.exports = __webpack_public_path__ + "img/logo.d171fb73.png";